/**
 * About Us page scroll reveal animations.
 * Adds the `.aboutus-reveal` class to target sections, then applies `.is-revealed`
 * when each section enters the viewport. Works in all modern browsers.
 */
(function () {
  function init() {
    var targets = document.querySelectorAll(
      '#shopify-section-media_with_content_founderStory, #shopify-section-media_with_content_ourVision, #shopify-section-section_faq'
    );

    if (!targets.length) return;

    // Tag each target with the reveal class so the CSS hides them initially.
    targets.forEach(function (el) {
      el.classList.add('aboutus-reveal');
    });

    // Fallback: if IntersectionObserver isn't supported, reveal everything immediately.
    if (typeof IntersectionObserver === 'undefined') {
      targets.forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -10% 0px',
      }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
